import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PassengersReportComponent } from './components/passengers-report/passengers-report.component';
import { TimeReportComponent } from './components/time-report/time-report.component';
import { TimereportconsolidateComponent } from './components/timereportconsolidate/timereportconsolidate.component';
import { SettlementComponent } from './components/settlement/settlement.component';
import { MasterComponent } from './components/master/master.component';
import { AuthGuard } from './guards/guards.component';
import { RouteComponent } from './components/route/route.component';
import { RoutesComponent } from './components/routes/routes.component';
import { DriversComponent } from './components/drivers/drivers.component';
import { PointsComponent } from './components/points/points.component';
import { RoutetraceComponent } from './components/routetrace/routetrace.component';
import { DriverComponent} from './components/driver/driver.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { CompanyComponent } from './components/company/company.component';
import { RateComponent } from './components/rate/rate.component';
import { ConsolidatedByPlateComponent } from './components/consolidated-by-plate/consolidated-by-plate.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ControlpointsComponent } from './components/controlpoints/controlpoints.component';
import { ControlpointComponent } from './components/controlpoint/controlpoint.component';
import { TransmissionVehiclesComponent } from './components/transmission-vehicles/transmission-vehicles.component';
import { HolidayCalendarComponent } from './components/holiday-calendar/holiday-calendar.component';
import { UserComponent } from './components/user/user.component';
import { UsersComponent } from './components/users/users.component';
import { AlertReportComponent } from './components/alert-report/alert-report.component';
import { AlarmUbicationComponent } from './components/alarm-ubication/alarm-ubication.component';
import { RouteDisplayComponent } from './components/route-display/route-display.component';
import { PicoTimesComponent } from './components/pico-times/pico-times.component';
import { DispatcherreportComponent } from './components/dispatcherreport/dispatcherreport.component';
import { DriverReportComponent } from './components/driver-report/driver-report.component';


const appRoutes: Routes = [
  {
    path: 'home',
    component: MasterComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component : LoginComponent },
      { path: 'login', component : LoginComponent },
      { path: 'dashboard', component : DashboardComponent},
      { path: 'passengersReport', component : PassengersReportComponent },
      { path: 'alertreport', component : AlertReportComponent },
      { path: 'timeReport', component : TimeReportComponent },
      { path: 'timeReportConsolidate', component : TimereportconsolidateComponent },
      { path: 'settlement', component : SettlementComponent },
      { path: 'consolidatedPlate', component : ConsolidatedByPlateComponent },
      { path: 'route/:idRoute', component : RouteComponent },
      { path: 'routes', component : RoutesComponent },
      { path: 'points', component : PointsComponent },
      { path: 'controlpoint/:idCtrlPoint', component : ControlpointComponent },
      { path: 'controlpoints', component : ControlpointsComponent },
      { path: 'routetrace', component : RoutetraceComponent },
      { path: 'rates', component : RateComponent},
      { path: 'drivers', component : DriversComponent },
      { path: 'transmissionVehicles', component : TransmissionVehiclesComponent },
      { path: 'driver/:idDriver', component : DriverComponent },
      { path: 'companies', component : CompaniesComponent },
      { path: 'holidayCalendar', component : HolidayCalendarComponent },
      { path: 'company/:idCompany', component : CompanyComponent },
      { path: 'users', component : UsersComponent },
      { path: 'user/:idUser', component : UserComponent },
      { path: 'alarmubication', component : AlarmUbicationComponent },
      { path: 'routeDisplay', component : RouteDisplayComponent },
      { path: 'picoTimes', component : PicoTimesComponent },
      { path: 'dispatcherreport', component : DispatcherreportComponent },
      { path: 'driverreport', component : DriverReportComponent },
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: '**', component: LoginComponent },
];

export const appRoutingProviders: any[] = [];
export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/app.routing.ts